import { useState, useEffect } from "react";

export function useIsMobile(breakpoint = 640): boolean {
	const [mobile, setMobile] = useState(
		() => typeof window !== "undefined" && window.innerWidth < breakpoint
	);

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
		setMobile(mql.matches);
		const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
		mql.addEventListener("change", handler);
		return () => mql.removeEventListener("change", handler);
	}, [breakpoint]);

	return mobile;
}
